export const initialState = {
	pageLoadState: {},
	isPageLoadStateLoaded: false,
	isPageLoadStateLoading: false
};

export default {
	initialState
};
